import AndroidStrategy from './android.strategy'
import At6Strategy from './at6.strategy'
import Fmb920Strategy from './fmb920.strategy'
import Gt06Strategy from './gt06.strategy'
import Gv300Strategy from './gv300.strategy'
import Gv300WStrategy from './gv300w.strategy'
import Gv55Strategy from './gv55.strategy'
import Gv55WStrategy from './gv55w.strategy'
import QbitStrategy from './qbit.strategy'
import WetrackStrategy from './wetrack.strategy'

export default class ModemStrategyFactory {
    static create(model_gps: string) {
        switch (model_gps) {
            case 'Quecklink GV300N':
            case 'Quecklink GV300':
                return new Gv300Strategy()
            case 'Quecklink GV300W':
                return new Gv300WStrategy()
            case 'Quecklink GV55N':
            case 'Quecklink GV55':
                return new Gv55Strategy()
            case 'Quecklink GV55W':
                return new Gv55WStrategy()
            case 'Concox AT6':
                return new At6Strategy()
            case 'Android':
                return new AndroidStrategy()
            case 'Concox GT06':
            case 'Concox GT06N':
                return new Gt06Strategy()
            case 'Concox Wetrack':
                return new WetrackStrategy()
            case 'Concox QBIT':
                return new QbitStrategy()
            case 'Teltonika FMB130':
            case 'Teltonika FMC130':
            case 'Teltonika FMB920':
                return new Fmb920Strategy()
            default:
                return new Gv300Strategy()
        }
    }
}
